<template>
    <div>
        <div class="top">
            <div class="videoleft">
                <img @click="toback()" src="../../assets/img/video/ico_fh.svg" alt="" />
                {{ chaptername }}
            </div>
            <div class="videoright">
                <img src="../../assets/img/index/course.jpg" alt="" />
                <!-- 文文跑江湖 -->
            </div>
        </div>

        <body>
            <div id="J_prismPlayer"></div>
        </body>
    </div>
</template>

<script>
//导出aliplayer
import { queryVideoUrl,updateVideoUpdateTime ,getStudyHistoryByChapterId} from '@/api/chapter.js';
import { tryPlayCourse} from '@/api/course.js';

export default {
    data() {
        return {

            text: '',
            i: 0,
            chaptername: '',
            screenHeight: 0,
            posRight: -325,
            list: [
                { img: require('../../assets/img/video/player_icon_4.svg'), img1: require('../../assets/img/video/player_icon_1_action.svg'), name: ' 章节列表' },
            ],
            chartArr: [{ con: '自己的1' }],
            rightIndex: '',
            id: '',
            url: '',
            videoId: '',
			start_time :'0',
			update_time :'0',
			chapters:[],
			play_index:'',
			time:0
        };
    },
    mounted() {
		//课程courseId
        this.courseId = this.$route.query.courseId;
        var params = {
			courseId:this.courseId,
        };
        tryPlayCourse(params).then(res => {
			this.chaptername = res.data.chapterName;
            this.startVideo(this.courseId, res.data.url);
			console.log(res.data.url)
        });	
		this.chapters = JSON.parse(localStorage.getItem('chapters'));
		console.log('this.chapters:', this.chapters) 
		//alert(JSON.stringify(this.chapters));
    },
    methods: {
        startVideo(chapterId,url) {
			var me = this;
            this.player = window.Aliplayer(
                {
                    id: 'J_prismPlayer',
                    width: '100%',
                    height: '100%',
                    videoHeight: '80vh',
                    source: url, //视频的播放凭证，可以在通用媒体管理服务控制台获取。
                },
                function (player) {

					player.on('ended', () => {
				   
					});					
					player.on('timeupdate', () => { // 播放位置发生改变时触发，仅H5播放器。
					   var currentTime = player.getCurrentTime();
					   if(currentTime > 180){
						   me.$message.error("您只能试学2分钟课程,如想更多学习，可前往个人中心报名！");
						   me.player.seek(0);
					   }
					});
                }
            );
            this.player.play();
        },
        handleSelect(video,index) {
			debugger;
			this.play_index = index;
			if(video.type=='ml'){
				return;
			}
			this.$router.push({
				path: '/course/video',
				query: {
					id: video.id,
					videoId: video.sourceUrl,
					name: video.chapterName,
					year:localStorage.getItem('year'),
				}
			});
			location.reload();
            /* if (!video.disablied) {
                this.player.loadByUrl(video.url);
            }
            this.videos.forEach(i => {
                i.disablied = i === video;
            }); */
        },
   
        toleft(index) {
            if (index === this.rightIndex) {
                this.posRight = this.posRight < 0 ? 0 : -325;
            } else {
                this.posRight = 0;
            }
            this.rightIndex = index;
        },
        toback() {
            this.$router.back(-1);
        },
        tosend() {
            console.log(this.text);
            if (!this.text) {
                return this.$toast('请输入内容');
            }
            this.chartArr.push({ con: this.text });
            this.text = '';
        },
        avtvideo(i) {
            this.i = i;
        },
    },
};
</script>

<style lang="less" scoped>
.videoList {
}
.top {
    height: 70px;
    background: #383838;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 40px;
    .videoleft {
        font-size: 20px;
        color: #ffffff;
        vertical-align: middle;
        img {
            cursor: pointer;
            width: 15px;
            height: auto;
            vertical-align: middle;
            margin-right: 25px;
        }
    }
    .videoright {
        img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            border: 1px solid #707070;
            margin-right: 13px;
            vertical-align: middle;
        }
        vertical-align: middle;
        font-size: 16px;
        color: #ffffff;
    }
}
.video-player {
    // position: relative;
}
// 侧边选择栏
.rightlist {
    position: fixed;
    right: 5px;
    top: 50%;
    transform: translate(0, -50%);
    transition: 0.5s;
    .list {
        img {
            width: 20px;
            height: auto;
            margin: 0 auto;
            display: block;
            padding-top: 20px;
            margin-bottom: 5px;
        }
        text-align: center;
        width: 30px;
        height: auto;
        background: #383838;
        padding:0 8px 15px 12px;
        text-align: center;
        font-size: 16px;
        color: #ffffff;
        margin-top: -10px;
      cursor: pointer;
      border-radius: 20px 0 0 20px;

    }
    .actlist {
        background: #2961ef;
    }
}
// 侧边弹出框
.openright {
    position: fixed;
    right: -325px;
    top: 0;
    bottom: 0;
    width: 325px;
    transition: 0.5s;
  z-index: 11;

  background: rgba(0,0,0,.8);
  backdrop-filter: blur(5px) brightness(110%);
  -webkit-backdrop-filter: blur(5px) brightness(110%);
  border-left: 7px solid #2961ef;

    .topbox {
        padding: 18px 11px;
        .openbox {
            margin-bottom: 22px;
            img {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                display: inline-block;
                vertical-align: top;
                margin-right: 10px;
            }
            .img1 {
                margin-left: 10px;
            }
            .rightcont {
                display: inline-block;
                .name {
                    font-size: 14px;
                    color: #cccccc;
                    margin-bottom: 3px;
                }
                .ourname {
                    text-align: right;
                }
                .content {
                    width: 210px;
                    background: #5a5a5a;
                    border-radius: 10px 10px 10px 10px;
                    padding: 13px;
                    font-size: 16px;
                    color: #d1d1d1;
                    position: relative;
                    img {
                        display: block;
                        width: 12px;
                        height: auto;
                        position: absolute;
                        left: -10px;
                        top: 15px;
                    }
                }
                .ourcont {
                    background: #ee7112;
                    border-radius: 10px 10px 10px 10px;
                    font-size: 16px;
                    color: #ffffff;
                    img {
                        display: block;
                        width: 12px;
                        height: auto;
                        position: absolute;
                        left: 233px !important;
                        top: 15px !important;
                    }
                }
            }
        }
    }
    .bottom {
        box-shadow: 0px -3px 20px 1px rgba(241, 241, 241, 0.21176470588235294);
        padding: 18px;
        position: absolute;
        bottom: 0;
        right: 0;
        left: 0;
        textarea {
            width: 96%;
            height: 100px;
            padding: 10px;
            background: #ffffff;
            border-radius: 6px 6px 6px 6px;
            border: 1px solid #707070;
        }
        .submit {
            cursor: pointer;
            margin: 20px auto 0;
            width: 142px;
            height: 37px;
            line-height: 37px;
            text-align: center;
            background: #2961ef;
            border-radius: 27px 27px 27px 27px;
            font-size: 16px;
            color: #ffffff;
        }
    }
    .courlist {
        padding: 0 30px;
        .title {
            padding-left: 10px;
            line-height: 20px;
            font-size: 20px;
            font-weight: 300;
            color: #cccccc;
            border-left: 7px solid #2961ef;
            margin: 30px 0 20px;
        }
        .backg {
            background: rgba(250, 250, 250, 1);
        }
        .video {
            width: 100%;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid rgba(112, 112, 112, 0.14);
            padding: 0 22px;
            height: 50px;
            img {
                width: 20px;
                height: auto;
                margin-right: 5px;
                display: inline-block;
                vertical-align: middle;
            }
            .tiitle {
                display: inline-block;
                vertical-align: middle;
                font-size: 16px;
                width: 55%;
                font-weight: 300;
                color: #999999;
                overflow: hidden;
                height: 50px;
                line-height: 50px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .plan {
                margin-left: 300px;
                font-size: 16px;
                color: #2961ef;
            }
            .right {
            }
        }
    }
}
.prism-player {
    height: calc(100vh - 72px) !important;
    overflow: hidden;
}
</style>